var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "feedbackReceivedView height-100" },
    [
      _c("van-overlay", {
        attrs: { show: _vm.overlayShow, "z-index": "9999" },
        on: {
          click: function ($event) {
            _vm.show = false
          },
        },
      }),
      _c(
        "div",
        {
          staticClass:
            "bg-FF flex row-center fixed width-100 abso z-999 pos-t-0 font-28 cor-66 p-24",
        },
        [
          _c("van-icon", {
            class:
              _vm.dateArray.indexOf(_vm.selectedDate) <= 0
                ? "disabled-icon"
                : "",
            attrs: { name: "arrow-left" },
            on: {
              click: function ($event) {
                return _vm.clickDate("prev")
              },
            },
          }),
          _c("div", { staticClass: "p-l-10 cor-66 p-r-10" }, [
            _vm._v(_vm._s(_vm.selectedDate)),
          ]),
          _c("van-icon", {
            class:
              _vm.dateArray.indexOf(_vm.selectedDate) >=
              _vm.dateArray.length - 1
                ? "disabled-icon"
                : "",
            attrs: { name: "arrow" },
            on: {
              click: function ($event) {
                return _vm.clickDate("next")
              },
            },
          }),
        ],
        1
      ),
      _vm.projectList.length == 0
        ? _c(
            "div",
            {
              staticClass:
                "width-100 height-100 noDataBox flex row-center col-center",
            },
            [
              _c("img", {
                staticClass: "width-50 m-l-40",
                attrs: {
                  src: require("@/assets/icon/feedbackStatistics/noData.png"),
                  alt: "没有数据",
                },
              }),
              _c("p", { staticClass: "cor-66 m-t-24 font-28" }, [
                _vm._v("该员工当天没有工作反馈"),
              ]),
            ]
          )
        : _c(
            "div",
            { staticClass: "p-b-98 p-l-24 p-r-24 m-b-80 p-t-100" },
            [
              _vm.feedbackHour
                ? _c("div", { staticClass: "flex row-between p-t-16 p-b-16" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "b-tr-r-40 b-br-r-40 font-32 p-t-10 p-b-10 cor-33 p-r-24 p-l-24",
                        class: _vm.getFeedbackHourStyle(_vm.feedbackHour),
                      },
                      [_vm._v(_vm._s(_vm.feedbackHourCn))]
                    ),
                    _c("div", { staticClass: "cor-66 font-32" }, [
                      _vm._v(_vm._s(_vm.feedbackHour) + "小时"),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "van-list",
                {
                  attrs: {
                    "immediate-check": false,
                    finished: _vm.finished,
                    "finished-text": "没有更多了",
                  },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.loading,
                    callback: function ($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading",
                  },
                },
                _vm._l(_vm.projectList, function (projectItem, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "feedbackReceivedViewList" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "feedbackReceivedViewTitle m-b-24 m-t-24",
                        },
                        [
                          _c("img", {
                            staticClass: "w-40 h-38 m-r-16",
                            attrs: {
                              src: require("@/assets/icon/feedbackStatistics/projectIcon.png"),
                              alt: "项目",
                            },
                          }),
                          _c("span", { staticClass: "cor-33 font-28" }, [
                            _vm._v(_vm._s(projectItem.projectName)),
                          ]),
                        ]
                      ),
                      _vm._l(projectItem.tasks, function (tasksItem, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass:
                              "bg-FF p-t-32 p-b-32 p-l-24 p-r-24 font-28 rela",
                            class:
                              index == projectItem.tasks.length - 1
                                ? ""
                                : "m-b-24",
                          },
                          [
                            _c("div", { staticClass: "m-b-24 flex col-top" }, [
                              _c("div", { staticClass: "cor-66" }, [
                                _vm._v("任务："),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "cor-33 flex-1" }, [
                                _vm._v(" " + _vm._s(tasksItem.taskName)),
                              ]),
                            ]),
                            _c("div", { staticClass: "m-b-24 flex col-top" }, [
                              _c("div", { staticClass: "cor-66" }, [
                                _vm._v("工作内容："),
                              ]),
                              _c("div", { staticClass: "cor-33 flex-1" }, [
                                _vm._v(_vm._s(tasksItem.message)),
                              ]),
                            ]),
                            _c("div", { staticClass: "m-b-24 flex col-top" }, [
                              _c("div", { staticClass: "cor-66" }, [
                                _vm._v("任务投入工时："),
                              ]),
                              _c("div", { staticClass: "cor-33 flex-1" }, [
                                _vm._v(_vm._s(tasksItem.hour) + "小时"),
                              ]),
                            ]),
                            _c("div", { staticClass: "m-b-24 flex col-top" }, [
                              _c("div", { staticClass: "cor-66" }, [
                                _vm._v("附件："),
                              ]),
                              _c(
                                "div",
                                { staticClass: "cor-33 flex-1" },
                                [
                                  _c("fileComponent", {
                                    ref: "fileComponent",
                                    refInFor: true,
                                    attrs: { tasksItem: tasksItem },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c(
                                  "van-button",
                                  {
                                    staticClass:
                                      "w-300 h-50 tasksBtn rela font-28",
                                    attrs: { type: "primary", round: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.commentClick(
                                          projectItem,
                                          tasksItem
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v("评论 "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              Number(tasksItem.commentNum) > 0,
                                            expression:
                                              "Number(tasksItem.commentNum)>0",
                                          },
                                        ],
                                        staticClass:
                                          "abso pos-neg-t-28 pos-r-8 font-45 commentBox",
                                      },
                                      [_vm._v("●")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "abso pos-t-0 pos-r-0" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-130 h-30 l-h-30 progressBox font-22 text-right p-r-24",
                                  class:
                                    tasksItem.progress == 100
                                      ? "progressBoxBai"
                                      : "",
                                },
                                [_vm._v(_vm._s(tasksItem.progress) + "%")]
                              ),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
            ],
            1
          ),
      _c(
        "div",
        {
          staticClass:
            "p-l-24 p-r-24 p-b-24 fixed width-100 abso pos-b-0 backBox",
        },
        [
          _c(
            "van-button",
            {
              staticClass: "width-100 h-60 cor-33 font-28",
              on: {
                click: function ($event) {
                  return _vm.backList()
                },
              },
            },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
      _c("commentForm", { ref: "commentForm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }